import { render, staticRenderFns } from "./template.vue?vue&type=template&id=ad953440&scoped=true&"
var script = {}
import style0 from "./template.vue?vue&type=style&index=0&id=ad953440&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad953440",
  null
  
)

export default component.exports